import { getAppDownloadLinks, FALLBACK_DOWNLOAD_LINKS, type AppDownloadLinksResponse } from '~/api/download'

/** 全局共享下载地址，useAsyncData 按 key 自动去重，SSR 首屏调一次。 */
export const useAppDownloadLinks = () => {
  return useAsyncData<AppDownloadLinksResponse>('app-download-links', () => getAppDownloadLinks(), {
    default: () => FALLBACK_DOWNLOAD_LINKS,
  })
}
